const TFCookies = {
  CODE: {
    ISO: 'CK_ISO_CODE',
    LANG: 'CK_LANG_CODE',
    DISPLAY_TYPE: 'CK_DISPLAY_TYPE',
    CIP_RPDETAILS: "cip_rpDetails"
  }
};

export default TFCookies;